import React, { useState, useEffect } from "react";
import { RefreshCw,Check, X } from "lucide-react";
import api from "../../api/api";
import * as S from "./styles";
import { toast } from "react-toastify";

const Inventory = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("Todos");

  const loadProducts = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/products");
      setItems(data || []);
    } catch (err) {
      toast.error("Erro ao carregar.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProducts();
  }, []);

  const toggleAvailability = async (id, currentStatus) => {
    try {
      setItems((prev) =>
        prev.map((p) =>
          p.id === id ? { ...p, available: !currentStatus } : p,
        ),
      );
      await api.patch(`/products/${id}`, { available: !currentStatus });
    } catch (err) {
      toast.error("Erro ao atualizar.");
      loadProducts();
    }
  };

  const categories = ["Todos", ...new Set(items.map((i) => i.category))];
  const filtered =
    filter === "Todos" ? items : items.filter((i) => i.category === filter);

  if (loading)
    return (
      <S.LoadingArea>
        <RefreshCw size={32} />
      </S.LoadingArea>
    );

  return (
    <S.Container>
      <S.Header>
        <div className="title">
          <h1>Cardápio</h1>
          <p>{items.length} itens cadastrados</p>
        </div>
        <button className="refresh-btn" onClick={loadProducts}>
          <RefreshCw size={20} />
        </button>
      </S.Header>

      <S.FilterBar>
        {categories.map((cat) => (
          <button
            key={cat}
            className={filter === cat ? "active" : ""}
            onClick={() => setFilter(cat)}
          >
            {cat}
          </button>
        ))}
      </S.FilterBar>

      <S.Grid>
        {filtered.map((product) => (
          <S.ProductCard key={product.id} available={product.available}>
            <div className="main-info">
              <span className="cat">{product.category}</span>
              {product.in_stock === false && (
                <span style={{ color: "#ef4444", fontSize: 12, fontWeight: 700 }}>
                  Sem ingrediente em estoque — fora do site
                </span>
              )}
              <h3>{product.name}</h3>
              <div className="price">R$ {Number(product.price).toFixed(2)}</div>
            </div>

            <S.SwitchArea>
              <button
                className={`status-toggle ${product.available ? "active" : "inactive"}`}
                onClick={() =>
                  toggleAvailability(product.id, product.available)
                }
                title={
                  product.available ? "Desativar Produto" : "Ativar Produto"
                }
              >
                <div className="knob">
                  {product.available ? <Check size={12} /> : <X size={12} />}
                </div>
                <span>{product.available ? "Ativo" : "Pausado"}</span>
              </button>
            </S.SwitchArea>
          </S.ProductCard>
        ))}
      </S.Grid>
    </S.Container>
  );
};

export default Inventory;
